import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/saif-dc/DC/projects/react-node-js/ucb/components/research/ForgetPassword.jsx");
;
import(/* webpackMode: "eager" */ "/home/saif-dc/DC/projects/react-node-js/ucb/components/research/Login.jsx");
